export class NazionalitaItem {
	constructor() {
		this.itemID = null;
		this.nazionalita = null;
		this.descrizione = null;
	}
	itemID: number;
	nazionalita: string | null;
	descrizione: string | null;
}